<template>
  <div>
    <el-form-item
      v-if="quote != 2"
      :label="label"
      :label-width="quote ? '110px' : '0px'"
    >
      <div class="imgUrl" v-if="quote && config[field.key]">
        <img :src="config[field.key]" alt="" @click="showDialog" />
        <div class="icon" @click.stop="cancel"></div>
      </div>
      <div
        class="imgUrl"
        v-else-if="!quote && config[field.key][index][imgName]"
      >
        <img
          :src="config[field.key][index][imgName]"
          alt=""
          @click="showDialog"
        />
        <div class="icon" @click.stop="cancel"></div>
      </div>
      <div class="img_bg" @click="showDialog" v-else>+ 上传图片</div>
    </el-form-item>
    <el-dialog
      title="请选择图片"
      :visible.sync="dialog.visible"
      @close="closeDialog"
      width="60%"
    >
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="共享素材空间" name="common">
          <el-select v-model="tabs_id" placeholder="请选择" @change="handleTab">
            <el-option
              v-for="(item, index) in common_category_list"
              :key="index"
              :label="item.category_name"
              :value="item.sort_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="category_id"
            placeholder="请选择"
            @change="handleCategory"
          >
            <el-option
              v-for="(item, index) in categoryData"
              :key="index"
              :label="item.category_name"
              :value="item.sort_id"
            >
            </el-option>
          </el-select>
        </el-tab-pane>
        <el-tab-pane label="个人素材空间" name="single" class="single">
          <el-select
            v-model="single_sort_id"
            placeholder="请选择"
            @change="handleSingle"
          >
            <el-option
              v-for="(item, index) in single_category_list"
              :key="index"
              :label="item.sort_name"
              :value="item.sort_id"
            >
            </el-option>
          </el-select>
          <image-upload
            v-on:uploaded="handleUpload"
            className="upload-image-btn-box"
            class="uplaod-box"
          >
            <div class="upload">上传素材</div>
          </image-upload>
        </el-tab-pane>
      </el-tabs>
      <InfiniteScroll
        class="pic-main"
        :infinite-scroll="load"
        :infinite-scroll-immediate="false"
        :infinite-scroll-disabled="page.disabled"
        v-if="imgList.length > 0"
        v-loading="loading"
      >
        <div class="ImgBox" v>
          <div class="item" v-for="(item, index) in imgList" :key="index">
            <img :src="mini(item.url, { w: 100, limit: 1 })" alt="" />
            <div class="mask">
              <div class="btn" @click="getImgUrl(item.url)">选择</div>
            </div>
          </div>
        </div>
      </InfiniteScroll>
    </el-dialog>
  </div>
</template>

<script>
import { mini } from "@/js/miniImg";
import { getSortList, getCommonList } from "@/views/picture/common.js";
import imageUpload from "@/components/ImageUploaderMultiple.vue";
export default {
  name: "tms-type-choose-photo",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    // 1默认名称，0自定义名称
    quote: {
      type: Number,
      default: 1,
    },
    index: {
      type: Number,
      default: 0,
    },
    imgName: {
      type: String,
      default: "image_url",
    },
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      activeName: "common",
      common_category_list: [],
      tabs_id: "",
      parent_id: "",
      categoryData: [],
      category_id: "",
      page: {
        currentPage: 0,
        pageSize: 50,
        disabled: false,
        totalCount: 0,
      },
      imgList: [],
      single_category_list: [],
      single_sort_id: "",
      api: "api/test/material/list",
      mode: "common",
      imgUrl: "",
      fileList: [],
      uploadParams: {
        host: "",
      },
      loading: false,
      source: "", // 选择图片来源
    };
  },
  computed: {
    label() {
      return !this.quote ? "" : this.field.name + "：";
    },
  },
  components: {
    imageUpload,
  },

  created() {
    this.getCommonListData();
  },

  methods: {
    mini,
    closeDialog() {
      this.dialog.visible = false;
    },
    showDialog() {
      this.dialog.visible = true;
    },
    handleClick(value) {
      this.mode = value.name;
      if (value.name === "common") {
        this.imgList = [];
        this.api = "api/test/material/list";
        this.getCommonListData();
      }
      if (value.name === "single") {
        this.imgList = [];
        this.api = "api/test/images/list";
        this.getSortList();
      }
    },
    // 获取公共分类
    async getCommonListData() {
      try {
        const data = await getCommonList();
        this.common_category_list = data;
        this.tabs_id = data[0].sort_id;
        // console.log(data, "公共分类列表");
        if (data.length) {
          this.getCategory(this.tabs_id);
        }
      } catch (error) {
        console.log(error);
      }
    },

    //获取公共分类的category
    async getCategory(sortId) {
      try {
        const data = await getCommonList(sortId);
        this.categoryData = data;
        if (data[0].sort_id) {
          this.category_id = data[0].sort_id;
        }
        // console.log(data, "category的data");
        this.getImgList(true);
      } catch (error) {
        console.error(error);
      }
    },

    // 获取图片列表
    getImgList(init = false) {
      if (init) {
        this.page.currentPage = 1;
      } else {
        this.page.currentPage++;
      }
      let params = {};
      if (this.mode === "common") {
        params = {
          count: this.page.pageSize,
          page: this.page.currentPage,
          category_id: this.category_id,
        };
      }
      if (this.mode === "single") {
        params = {
          count: this.page.pageSize,
          page: this.page.currentPage - 1,
          sort_id: this.single_sort_id.toString(),
        };
      }

      lib.tmsapi.get({
        api: this.api,
        data: params,
        success: (res) => {
          let data = [];
          if (res && res.data && res.data.length) {
            data = res.data;
            this.page.totalCount = res.total;
          }
          if (this.page.currentPage === 1) {
            this.imgList = data;
          } else {
            this.imgList.push(...data);
          }
          this.page.disabled = this.imgList.length >= this.page.totalCount;
          // console.log(this.imgList, "获取的图片");
        },
      });
    },

    handleTab(sortId) {
      this.getCategory(sortId);
    },

    handleCategory(val) {
      this.getImgList(true);
    },

    load() {
      this.getImgList();
    },

    handleSingle(val) {
      this.getImgList(true);
    },

    // 获取个人列表分类
    async getSortList() {
      try {
        const res = await getSortList();
        this.single_category_list = res;
        this.single_sort_id = res[0].sort_id;
        if (this.single_sort_id !== "") {
          this.getImgList(true);
        }
      } catch (error) {
        console.error(error);
      }
    },

    // img的地址
    getImgUrl(url) {
      if (this.quote === 2) {
        this.$emit("selectUrl", url);
      } else if (this.quote === 1) {
        this.$set(this.config, this.field.key, url);
      } else {
        this.$set(this.config[this.field.key][this.index], this.imgName, url);
      }
      this.dialog.visible = false;
    },
    cancel() {
      if (this.quote === 1) {
        this.$set(this.config, this.field.key, "");
      }
      if (this.quote === 0) {
        this.config[this.field.key][this.index][this.imgName] = "";
      }
    },

    // 上传素材
    async handleUpload(srcList, fileName) {
      try {
        this.loading = true;
        const params = {
          url: srcList,
          name: fileName,
          sort_id: this.single_sort_id,
        };
        lib.tmsapi.post({
          api: "api/test/images/add",
          data: params,
          success: (res) => {
            this.$message.success({
              message: "添加图片成功",
              type: "info",
              center: true,
            });

            this.getImgList(true);
            this.loading = false;
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.img_bg {
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #cccc;
  cursor: pointer;
  border-radius: 6px;
}
.imgUrl {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  background-color: #f1f0f0;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;
    object-fit: contain;
  }
}
.imgUrl:hover .icon {
  display: block;
}
.icon {
  display: none;
  width: 30px;
  height: 30px;
  position: absolute;
  right: -30px;
  top: -30px;
  transform: translate(-50%, 50%);
  background: url("https://mktv-in-cdn.mockuai.com/16394739795728603.png")
    no-repeat;
  background-size: contain;
  cursor: pointer;
}
.ImgBox {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 100px;
    height: 100px;
    overflow: hidden;
    background-color: #f1f0f0;
    margin-right: 15px;
    margin-top: 10px;
    padding: 5px 0;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: contain;
    }
  }

  .item:hover .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    top: 0;
  }
  .item:hover .btn {
    display: block;
  }
  .mask {
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      display: none;
      font-size: 12px;
      padding: 5px 10px;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 3px;
    }
  }
}
.pic-main {
  margin: 10px 0;
  max-height: 500px;
  overflow-y: scroll;
}
.single {
  display: flex;
  justify-content: space-between;
  .upload {
    font-size: 14px;
    color: #fff;
    background-color: #409eff;
    cursor: pointer;
    height: 60px;
    line-height: 40px;
  }
}
::v-deep .el-upload-dragger {
  height: 40px !important;
  width: 80px;
  border: none !important;
}
</style>
